// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    updatePrintConf as updatePrintConfAPI,
} from '../../helpers/';

import { printConfApiResponseError, printConfApiResponseSuccess } from './actions';
import { PrintConfActionTypes } from './constants';

function* updatePrintConf({ payload: printConf }) {
    try {
        const response = yield call(updatePrintConfAPI, { ...printConf })
        const printConfItem = response.data.data
        yield put(printConfApiResponseSuccess(PrintConfActionTypes.UPDATE_PRINT_CONF, printConfItem))
    } catch (error) {
        yield put(printConfApiResponseError(PrintConfActionTypes.UPDATE_PRINT_CONF, error))
    }
}

export function* watchUpdatePrintConf(): any {
    yield takeEvery(PrintConfActionTypes.UPDATE_PRINT_CONF, updatePrintConf)
}

function* printConfSaga(): any {
    yield all([
        fork(watchUpdatePrintConf),
    ]);
}

export default printConfSaga;
